
import inputNumber from '../inputNumber'
import clickoutside from './clickOutSide'
import Int from './int'
import preventReClick from './preventReClick'
import resize from './resize'


const directives = {
    inputNumber,clickoutside,
    Int,preventReClick,resize

}

export default {
    install(Vue){
        Object.keys(directives).forEach(key =>{
            // console.log("🚀 ~ key", key)
            Vue.directive(key,directives[key])
        })
    }
}
